var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarProjectsIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 15,
  viewBox: "0 0 18 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 2.5H11.0836L8.91641 0.875C8.69972 0.713324 8.43676 0.625671 8.16641 0.625H4.625C4.29348 0.625 3.97554 0.756696 3.74112 0.991116C3.5067 1.22554 3.375 1.54348 3.375 1.875V3.125H2.125C1.79348 3.125 1.47554 3.2567 1.24112 3.49112C1.0067 3.72554 0.875 4.04348 0.875 4.375V13.125C0.875 13.4565 1.0067 13.7745 1.24112 14.0089C1.47554 14.2433 1.79348 14.375 2.125 14.375H14.0695C14.3825 14.3746 14.6825 14.2501 14.9038 14.0288C15.1251 13.8075 15.2496 13.5075 15.25 13.1945V11.875H16.5695C16.8825 11.8746 17.1825 11.7501 17.4038 11.5288C17.6251 11.3075 17.7496 11.0075 17.75 10.6945V3.75C17.75 3.41848 17.6183 3.10054 17.3839 2.86612C17.1495 2.6317 16.8315 2.5 16.5 2.5ZM14 13.125H2.125V4.375H5.66641L8 6.125C8.10818 6.20614 8.23977 6.25 8.375 6.25H14V13.125ZM16.5 10.625H15.25V6.25C15.25 5.91848 15.1183 5.60054 14.8839 5.36612C14.6495 5.1317 14.3315 5 14 5H8.58359L6.41641 3.375C6.19972 3.21332 5.93676 3.12567 5.66641 3.125H4.625V1.875H8.16641L10.5 3.625C10.6082 3.70614 10.7398 3.75 10.875 3.75H16.5V10.625Z",
  fill: "#7A757F"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarProjectsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_projects_icon.57218b3799c8905dfe1dce5558651793.svg";